import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["clsPrefix", "placement", "children", "overlayClassName", "title", "content"];

var _this = this;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import classNames from 'classnames';
import useMergedState from 'rc-util/lib/hooks/useMergedState';
import KeyCode from 'rc-util/lib/KeyCode';
import Tooltip from '../../wui-tooltip/src';
import Button from '../../wui-button/src';
import Icon from "../../wui-icon/src";
import { getTransitionName, getRenderPropValue, cloneElement } from '../../wui-core/src/utils/createAntdUtils';
import i18n from './i18n';
import { getComponentLocale } from '../../wui-locale/src/tool';
import { prefix } from "../../wui-core/src/index.js";

var convertLegacyProps = function convertLegacyProps(type) {
  if (type === 'danger') {
    return {
      danger: true
    };
  }

  return {
    type: type
  };
}; // export interface PopconfirmProps extends AbstractTooltipProps {
//   title: React.ReactNode | RenderFunction;
//   disabled?: boolean;
//   onConfirm?: (e?: React.MouseEvent<HTMLElement>) => void;
//   onCancel?: (e?: React.MouseEvent<HTMLElement>) => void;
//   okText?: React.ReactNode;
//   okType?: LegacyButtonType;
//   cancelText?: React.ReactNode;
//   okButtonProps?: ButtonProps;
//   cancelButtonProps?: ButtonProps;
//   icon?: React.ReactNode;
//   onVisibleChange?: (
//     visible: boolean,
//     e?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLDivElement>,
//   ) => void;
// }
// export interface PopconfirmState {
//   visible?: boolean;
// }
// export interface PopconfirmLocale {
//   okText: string;
//   cancelText: string;
// }


var Popconfirm = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useMergedState = useMergedState(false, {
    value: props.visible,
    defaultValue: props.defaultVisible
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      visible = _useMergedState2[0],
      setVisible = _useMergedState2[1];

  var settingVisible = function settingVisible(value, e) {
    var _props$onVisibleChang;

    setVisible(value);
    props.onRootClose && !value && props.onRootClose();
    (_props$onVisibleChang = props.onVisibleChange) === null || _props$onVisibleChang === void 0 ? void 0 : _props$onVisibleChang.call(props, value, e);
  };

  var onConfirm = function onConfirm(e) {
    var _props$onConfirm;

    e.stopPropagation();
    settingVisible(false, e);
    (_props$onConfirm = props.onConfirm) === null || _props$onConfirm === void 0 ? void 0 : _props$onConfirm.call(_this, e);
  };

  var onCancel = function onCancel(e) {
    var _props$onCancel;

    e.stopPropagation();
    settingVisible(false, e);
    (_props$onCancel = props.onCancel) === null || _props$onCancel === void 0 ? void 0 : _props$onCancel.call(_this, e);
  };

  var _onKeyDown = function onKeyDown(e) {
    if (e.keyCode === KeyCode.ESC && visible) {
      settingVisible(false, e);
    }
  };

  var onVisibleChange = function onVisibleChange(value) {
    var disabled = props.disabled;

    if (disabled) {
      return;
    }

    settingVisible(value);
  }; // TODO:// 多语
  // const local = getComponentLocale(props, this.context, 'Popconfirm', () => i18n);


  var renderOverlay = function renderOverlay(prefixCls) {
    var _classes;

    var popconfirmLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var okButtonProps = props.okButtonProps,
        cancelButtonProps = props.cancelButtonProps,
        color = props.color,
        title = props.title,
        content = props.content,
        cancelText = props.cancelText,
        cancel_btn = props.cancel_btn,
        close_btn = props.close_btn,
        okText = props.okText,
        okType = props.okType,
        icon = props.icon;
    var contentText = content ? content : title;
    var classes = (_classes = {}, _defineProperty(_classes, "".concat(prefixCls, "-inner-content"), true), _defineProperty(_classes, "".concat(prefixCls, "-").concat(color), color), _classes);
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(classes)
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-message")
    }, icon, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-message-title")
    }, getRenderPropValue(contentText))), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-buttons")
    }, cancel_btn ? cloneElement(cancel_btn, _objectSpread(_objectSpread({}, cancel_btn.props), {}, {
      onClick: onCancel
    })) : /*#__PURE__*/React.createElement(Button, _extends({
      onClick: onCancel,
      size: "small",
      colors: "secondary"
    }, cancelButtonProps), cancelText || popconfirmLocale.cancelText || "取消"), close_btn ? cloneElement(close_btn, _objectSpread(_objectSpread({}, close_btn.props), {}, {
      onClick: onConfirm
    })) : /*#__PURE__*/React.createElement(Button, _extends({
      onClick: onConfirm
    }, convertLegacyProps(okType), {
      size: "small"
    }, okButtonProps), okText || popconfirmLocale.okText || "确定")));
  };

  var customizePrefixCls = props.clsPrefix,
      placement = props.placement,
      children = props.children,
      overlayClassName = props.overlayClassName,
      title = props.title,
      content = props.content,
      restProps = _objectWithoutProperties(props, _excluded);

  var prefixCls = "".concat(prefix, "-popover");
  var prefixClsConfirm = "".concat(prefix, "-popconfirm");
  var overlayClassNames = classNames(prefixClsConfirm, overlayClassName);
  var overlay = renderOverlay(prefixCls);
  var rootPrefixCls = prefix;
  return /*#__PURE__*/React.createElement(Tooltip, _extends({}, restProps, {
    prefixCls: prefixCls,
    placement: placement,
    onVisibleChange: onVisibleChange,
    visible: visible,
    overlay: overlay,
    overlayClassName: overlayClassNames,
    ref: ref,
    transitionName: getTransitionName(rootPrefixCls, 'zoom-big', props.transitionName)
  }), cloneElement(children, {
    onKeyDown: function onKeyDown(e) {
      if ( /*#__PURE__*/React.isValidElement(children)) {
        var _children$props$onKey, _children$props;

        children === null || children === void 0 ? void 0 : (_children$props$onKey = (_children$props = children.props).onKeyDown) === null || _children$props$onKey === void 0 ? void 0 : _children$props$onKey.call(_children$props, e);
      }

      _onKeyDown(e);
    }
  }));
});
Popconfirm.defaultProps = {
  placement: 'top',
  trigger: 'click',
  okType: 'primary',
  icon: /*#__PURE__*/React.createElement(Icon, {
    type: "uf-i-c"
  }),
  disabled: false
};
export default Popconfirm;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-popconfirm/src/index.js